import { EMPTY_STRING } from "../../../shared/constants/client";

export interface FilterOptions {
  id: number;
  property: string;
  text: string;
}

export const defaultRowsPerPageOptions = [5, 10, 25];

export const sortOptions = [
  { key: EMPTY_STRING, text: "None" },
  { key: "userGroupName_asc", text: "By User Group Name asc" },
  { key: "userGroupName", text: "By User Group Name dsc" },
  { key: "description_asc", text: "By Description asc" },
  { key: "description", text: "By Description dsc" },
];

export const dynamicFilterOptions: FilterOptions[] = Object([
  { id: 1, property: "userGroupName", text: "By User Group Name" },
  { id: 2, property: "description", text: "By Description" },
  { id: 3, property: "username", text: "By Username" },
]);
